import { render, staticRenderFns } from "./ModuleSingle.vue?vue&type=template&id=5f2b12a2&scoped=true"
import script from "./ModuleSingle.vue?vue&type=script&lang=js"
export * from "./ModuleSingle.vue?vue&type=script&lang=js"
import style0 from "./ModuleSingle.vue?vue&type=style&index=0&id=5f2b12a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2b12a2",
  null
  
)

export default component.exports